<template lang="">
  <div>
    <div class="search ">
      <el-form :model="searchForm" class="demo-form-inline" size="small" label-width="80px">
        <el-col :span="6" class="formWidth">
          <el-form-item label="评委姓名">
            <el-input v-model="searchForm.name" placeholder="评委姓名"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8" class="formWidth">
          <el-form-item label="评委状态" >          
            <el-radio-group v-model="searchForm.flag">
              <el-radio-button label="">全部</el-radio-button>
              <el-radio-button label="1">启用</el-radio-button>
              <el-radio-button label="0">未启用</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="5"  class="formWidth" >
          <el-form-item label-width="15px">
            <el-button type="primary" @click="search()"><i class="fa fa-search"></i> 查询</el-button>
            <el-button type="success" @click="judgesAdd()"><i class="fa fa-plus"></i> 新增</el-button>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="3" class="formWidth" style="float: right;text-align: right;;">
          <el-form-item label="" label-width="0px">
            <el-dropdown >
              <el-button type="primary" size="small">
                批操作<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>黄金糕</el-dropdown-item>
                <el-dropdown-item>狮子头</el-dropdown-item>
                <el-dropdown-item>螺蛳粉</el-dropdown-item>
                <el-dropdown-item>双皮奶</el-dropdown-item>
                <el-dropdown-item>蚵仔煎</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-form-item>
          
        </el-col> -->
        
        <div class="clear"></div>
      </el-form>

    </div>
    <div class="clear"></div>
    <!-- <hr /> -->

    <div class="list " v-loading="loading">
        <ul>
          <li v-for="item in list">
            <div class="list_left">
              <!-- <div class="checkbox"><el-checkbox :v-model="false">&nbsp;</el-checkbox></div> -->
              <div class="logo">
                <el-image :src="imgBase+item.filephotoid" fit="cover"></el-image>
              </div>
              <div class="info">
                <p>
                  <b><span class="" title="姓名"><i class="fa fa-user"></i>{{item.name}} <i :class="(item.judgegender==1)?'fa fa-mars':'fa fa-venus'" :title="(item.judgegender==1)?'男':'女'"></i></span> </b>
                  <b><span class="" title="电话"><i class="fa fa-phone"></i>{{item.mobile|filterMobile}}</span></b>
                  <b>
                    <!-- <span class="" title="密码"><i class="fa fa-key"></i>{{item.passwd}}</span> -->
                    <span class="" title="评委状态"><i class="fa fa-arrow-right"></i>{{item.flag|filterStatus}}</span>
                  </b>
                </p>
                <p>                  
                  <span class="" title="所在公司"><i class="fa fa-bank"></i>{{item.company}}</span>
                  <b><span class="" title="职位"><i class="fa fa-vcard-o"></i>{{item.position}}</span>
                  </b>
                </p>
              </div>
            </div>
            <div class="list_right">
              <el-button size="mini" type="success" @click="judgesEdit(item)" plain>编辑</el-button>
              <el-button size="mini" type="primary" @click="judgesDelete(item.id,item.name)" plain>删除</el-button>
            </div>
          </li>
        </ul>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="total" :current-page="searchForm.page" @current-change="current_change" :page-size="searchForm.length"></el-pagination>
    </div>

    <!-- add/edit -->
    <el-dialog :title="(newJudges)?'创建评委':'编辑评委'" :visible.sync="judgesInfoDialog" :width="dialogWidth" :top="dialogTop">
      <el-form :model="judgesInfo" ref="judgesInfo" size="small" label-width="100px">
        <el-form-item label="头像" class="" prop="filephotoid" :rules="{required: true, message: '必填', trigger: 'blur'}">
          <el-upload class="avatar-uploader userpicture" action="" style="line-height: 0;" accept="image/png,image/gif,image/jpg,image/jpeg" :show-file-list="false" :http-request="changeImageUpload" :before-upload="handleBeforeUpload" placeholder="头像" title="头像">
            <el-image style="width:100px;height:100px;" v-if="judgesInfo.filephotoid" class="avatar" :src="imgBase+judgesInfo.filephotoid" fit="cover"></el-image>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="姓名" prop="name" :rules="{ required: true, message: '请填写', trigger: 'blur' }">
          <el-input v-model="judgesInfo.name" ></el-input>
        </el-form-item>
        <el-form-item label="性别"  prop="judgegender" :rules="{ required: true, message: '请填写', trigger: 'blur' }">          
          <el-radio-group v-model="judgesInfo.judgegender">
            <el-radio-button label="1">男</el-radio-button>
            <el-radio-button label="2">女</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="手机" prop="mobile" :rules="{ required: true, validator: validatePhone, trigger: 'blur' }">
          <el-input v-model="judgesInfo.mobile" placeholder="评委登录的手机号码"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="passwd" :rules="{ required: true, validator: validatePsw, trigger: 'blur' }">
          <el-input v-model="judgesInfo.passwd" placeholder="登录密码，由数字、字母（8-16位）组成"></el-input>
        </el-form-item>
        <el-form-item label="所在公司" prop="company" :rules="{ required: true, message: '请填写', trigger: 'blur' }">
          <el-input v-model="judgesInfo.company" ></el-input>
        </el-form-item>
        <el-form-item label="职位" prop="position" :rules="{ required: true, message: '请填写', trigger: 'blur' }">
          <el-input v-model="judgesInfo.position" ></el-input>
        </el-form-item>
        <el-form-item label="屏蔽企业">
          <el-input placeholder='可输入屏蔽企业的id，用逗号分隔，如“153,178,185”' v-model="judgesInfo.ids" ></el-input>
        </el-form-item>
        <el-form-item label="评委状态"  prop="flag" :rules="{ required: true, message: '请填写', trigger: 'blur' }">          
          <el-radio-group v-model="judgesInfo.flag">
            <el-radio-button label="1">启用</el-radio-button>
            <el-radio-button label="0">未启用</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="success" @click="judgesInfoDialog=false"><i class="fa fa-times"></i> 取 消</el-button>
        <el-button size="small" type="primary" @click="saveJudges('judgesInfo')"><i class="fa fa-check"></i> 保 存</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import * as API from '@/api/main'
export default {
  data(){
    return {
      loading:false,
      imgBase:this.$store.state.imgBaseUrl,//图片前缀
      searchForm:{
        page:1,
        length:10,
        flag:"",
      },
      judgesInfo:{
        filephotoid:"",
      },//评委信息
      judgesInfoDialog:false,//添加、编辑活动面板开关
      newJudges:true,
      list:[],
      total:0,
      dialogWidth:"500px",
      dialogTop:"15vh",
    }
  },
  watch:{

    "searchForm.flag":{
      handler: function() {
        this.search()
      },      
    }

  },
  filters:{
    filterStatus(value){
      let str = "";
      switch (Number(value)) {
        case 1:
          str = "启用";
          break;
        case 0:
          str = "未启用";
          break;
      }
      return str;
    },

    filterMobile(value){
      var tel = value;
      tel = "" + tel;
      var ary = tel.split("");
      ary.splice(3,4,"****");
      var tel1=ary.join("");
      return tel1;
    },
  },
  methods: {
    // 上传文件之前的钩子
    handleBeforeUpload(file){
      if(!(file.type === 'image/png' || file.type === 'image/gif' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
          this.$message({
              type: 'warning',
              message: '请上传格式为image/png, image/gif, image/jpg, image/jpeg的图片'
          });
          return false;
      }
      // console.log(file.size)
      let size = file.size / 1024 / 1024 ;
      if(size > .3) {
          this.$message({
              type: 'warning',
              message: '图片大小必须小于300K'
          });
          return false;
      }
    },

    //图片上传
    changeImageUpload(options) {
      let file = options.file
      let filename = file.name
      let fileReader = new FileReader();
      if (file) {
          fileReader.readAsDataURL(file)
      }
      fileReader.onload = () => {
          let base64Str = fileReader.result;
          API.ImgUpload({filephoto:base64Str}).then(res => {
            this.judgesInfo.filephotoid=res.data.filepath;
        })
      }
    },

    //获取列表
    getlist(){
      this.loading=true;
      API.GetJudgesList(this.searchForm).then(res=>{
        this.list=res.data.data;
        this.loading=false;
        this.total=res.data.total;
      })
    },

    //分页
    current_change(currentPage){
      // console.log(currentPage)
      this.searchForm.page = currentPage;
      this.getlist();
    },

    //查询
    search(){
      this.current_change(1);
    },

    //重置校验
    resetForm(formName) {
        this.$refs[formName].resetFields();
    },

    //校验手机号码
    validatePhone(rule, value, callback) {
      let phoneReg1 = /^1[3456789]\d{9}$/; //大陆手机号验证
      // let phoneReg2 = /^852(5|6|8|9)\d{7}$/;    //香港手机号验证
      if (!value) {
        return callback(new Error('请输入手机号码')) ;
      }
      setTimeout(() => {
        if (!phoneReg1.test(value) && value.indexOf("*")==-1) {
          callback(new Error('手机号码格式有误'));
        } else {
          callback();
        }
      }, 0)
    },

    //校验密码
    validatePsw(rule, value, callback) {
      let pswReg = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,16}$/; //有数字、密码，8-16位
      if (!value) {
        return callback(new Error('请输入密码')) ;
      }
      setTimeout(() => {
        if (!pswReg.test(value) && value.indexOf("*")==-1) {
          callback(new Error('由数字、字母（8-16位）组成'));
        } else {
          callback();
        }
      }, 0)
    },

    //新增
    judgesAdd(){
      this.newJudges=true;
      this.judgesInfoDialog=true;
      this.judgesInfo={
        filephotoid:"",//头像
        name:"",//姓名
        judgegender:"",//性别
        mobile:"",//手机
        passwd:"",//密码
        company:"",//公司
        position:"",//职位
        flag:"",//状态
        id:"",//id
        ids:"",//屏蔽企业id
      }
    },

    //编辑
    judgesEdit(item){
      this.newJudges=false;
      this.judgesInfoDialog=true;
      this.judgesInfo={
        filephotoid:item.filephotoid,//头像
        name:item.name,//姓名
        judgegender:item.judgegender,//性别
        mobile:item.mobile,//手机
        passwd:item.passwd,//密码
        company:item.company,//公司
        position:item.position,//职位
        flag:item.flag,//状态
        id:item.id,//id
        ids:item.ids,//屏蔽企业id
      }
    },

    //提交
    saveJudges(formName){
      this.$refs[formName].validate((valid) => {
          if (valid) {
            if(this.newJudges){
              API.JudgesAdd(this.judgesInfo).then(res=>{
                this.$message({
                  message: res.info,
                  type: 'success'
                });
                this.judgesInfoDialog=false;              
                this.resetForm(formName);
                this.search();
              })
            }else{
              API.JudgesEdit(this.judgesInfo).then(res=>{
                this.$message({
                  message: res.info,
                  type: 'success'
                });
                this.judgesInfoDialog=false;              
                this.resetForm(formName);
                this.getlist();
              })
            }            
          } else {
            return false;
          }
        });
    },

    //删除
    judgesDelete(id,name){
      this.$confirm('确定删除“'+name+'”评委?', '提示', {
          confirmButtonText: '确 定',
          cancelButtonText: '取 消',
          type: 'warning'
        }).then(() => {
          API.JudgesDelete({id:id}).then(res=>{        
            this.$message({
              message: res.info,
              type: 'success',
            })
            this.getlist();
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: res.info
          });          
        });
    },

    diffrentScreen(){
      if(document.body.clientWidth<1200){
        this.dialogWidth="100vw";
        this.dialogTop="5vh";
      }
    }

  },
  created() {
    this.getlist();
    
  },
  mounted() {
    this.diffrentScreen();
  },

}
</script>
<style scoped>
  .search{padding-bottom:20px;border-bottom: 1px #eee solid;}
.list {line-height: 2;;}
.list ul li{display:flex;justify-content:space-between;align-items:center;padding:10px;border-bottom: 1px solid #e7e7e7;}
.list ul li:nth-of-type(even){    background: #f6f6f6;}
.list ul li:hover{background:var(--mainColorOp)}
.list .list_left{display: flex;}
.list .list_left .checkbox{margin-right:5px;}
.list span{margin-right:1em;}
.list i.fa{color:var(--mainColor);margin-right:5px;width:16px;text-align: center;display: inline-block;}
.list span.workname{font-size:1em;}
.list span.workprize u{color:#999;}
.list .logo{padding:0 15px 0 5px;height:50px;}
.list .logo img{border-radius: 50%;}
.avatar-uploader-icon{font-size: 28px; color: #8c939d; width: 100px;height: 100px; line-height: 100px;text-align: center;}
.el-image{width: 50px; height: 50px;border-radius: 50%;}
.el-image img{height:100%;}
@media screen and (max-width: 1200px){
  .formWidth{width:100%;}
  .list ul li{display: block;}
  .list .list_left{flex-wrap:wrap;}
  .list_right{padding-left:15px;}
  .list b{display:block;}
  .list .info{padding-left:25px;}
  .el-image{width:100px;height:100px;}
  .list .logo{height:100px}
}
</style>